import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useQuery } from "react-query";
import { useAppSelector } from "redux/hooks";
import {
  CardData,
  LegendType,
  RowsData,
} from "api/interfaces/dashboardInterface.interface";
import ChartWrapper from "../graph/ChartWrapper";
import { useMemo, useState } from "react";
import {
  GetDashboardCountResponse,
  statsInterval,
} from "api/interfaces/widgetInterface.interface";
import { getDashboardPageViewCount } from "api/widgetAPI";
import {
  formatPercent,
  getCategory,
  getMenuName,
  getRowsAndItems,
  getUniqueLabelRowsData,
} from "utils/StatsUtil";

export default function ClientDevice(props: CardData) {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const [interval, setInterval] = useState<string>("1");
  const statsBestPageView = useQuery(
    [
      "statsBestPageView",
      selectedAccount.accountId,
      interval,
    ],
    () => {
      return getDashboardPageViewCount(Number(interval));
    },
    {
      retry: 0,
      refetchOnWindowFocus: false,
    }
  );
  const { rows, items } = useMemo(() => {
    const data = (statsBestPageView.data?.result ?? []).map(
      (item: GetDashboardCountResponse["result"][number]) => {
        const category = getCategory(item.view);
        let menuName = getMenuName(item.view, category?.children ?? []);
        if (menuName === "Organization" && category?.name === "Subscription") {
          menuName = "Subscription";
        }
        if (!menuName) menuName = category?.name ?? "Other";
        return {
          menuName: menuName,
          count: item.count,
        };
      }
    );
    let rows: RowsData[] = getUniqueLabelRowsData(data, "menuName");
    return getRowsAndItems(rows, props.items);
  }, [props.items, statsBestPageView.data]);
  const legend: LegendType[] = useMemo(() => {
    let legend: LegendType[] = [...rows] as unknown as LegendType[];
    const total = legend.reduce((acc, curr) => acc + Number(curr.value), 0);
    return items.map((item, index) => ({
      label: item.label,
      value: formatPercent(Number(rows[index].value ?? 0), total),
      color: item.color,
    }));
  }, [items, rows]);
  return (
    <ChartWrapper
      rows={rows}
      items={items}
      unit={"percent"}
      onChangeInterval={setInterval}
      interval={interval as statsInterval}
      isLoading={statsBestPageView.isLoading}
      legend={legend}
    />
  );
}
